import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  MdSearch,
  MdClear,
  MdDownload,
  MdChevronLeft,
  MdChevronRight,
  MdFirstPage,
  MdLastPage,
} from "react-icons/md";

import { getArticles, deleteArticle } from "api/article.api";
import ArticleTable from "components/articles/ArticleTable";
import BulkImportButton from "components/common/BulkImportButton";


export default function Articles() {
  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

  const [selectedOrganizer, setSelectedOrganizer] = useState(
    localStorage.getItem("company_id") || ""
  );

  const userId = "69579c6190a653b640e65639";

  const fetchData = async () => {
  const res = await getArticles({
    company_id: selectedOrganizer,
  });

  setData(Array.isArray(res.data?.data) ? res.data.data : []);
};


  useEffect(() => {
    fetchData();
  }, [selectedOrganizer]);

  useEffect(() => {
    const handleOrganizerChange = (e) => {
      setSelectedOrganizer(e.detail);
    };

    window.addEventListener("companyChanged", handleOrganizerChange);
    return () =>
      window.removeEventListener("companyChanged", handleOrganizerChange);
  }, []);

  const handleDelete = async (id) => {
    await deleteArticle(id, {
      is_deleted: true,
      deleted_by: userId,
    });
    fetchData();
  };

  const filteredData = data.filter(
    (item) =>
      item.title?.toLowerCase().includes(search.toLowerCase()) ||
      item.author?.toLowerCase().includes(search.toLowerCase())
  );

  const totalPages = Math.ceil(filteredData.length / limit);

  const paginatedData = filteredData.slice(
    (page - 1) * limit,
    page * limit
  );

  const exportCSV = () => {
    const headers = ["Title", "Author", "Status", "Published Date"];

    const rows = filteredData.map((a) => [
      a.title,
      a.author,
      a.status,
      a.published_date,
    ]);

    const csvContent =
      "data:text/csv;charset=utf-8," +
      [headers, ...rows].map((r) => r.join(",")).join("\n");

    const link = document.createElement("a");
    link.href = encodeURI(csvContent);
    link.download = "articles.csv";
    link.click();
  };

  return (
    <div className="p-4">
      <div className="flex justify-between items-center mb-4">
        <div className="flex items-center gap-2">
          <div className="relative">
            <MdSearch className="absolute left-3 top-2.5 text-gray-400 text-lg" />
            <input
              type="text"
              placeholder="Search articles..."
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                setPage(1);
              }}
              className="pl-10 pr-8 py-2 border rounded-md text-sm w-64"
            />
            {search && (
              <button
                onClick={() => setSearch("")}
                className="absolute right-2 top-2.5 text-gray-400"
              >
                <MdClear />
              </button>
            )}
          </div>

          <button
            onClick={exportCSV}
            className="flex items-center gap-1 px-2 py-1 bg-green-500 text-white rounded-lg"
          >
            <MdDownload /> CSV
          </button>
        </div>
         <div className="flex items-center gap-2">
            <BulkImportButton module="articles" label="Import Articles" onSuccess={fetchData} companyId={selectedOrganizer} />
              <Link
                to="/admin/articles/create"
                className="bg-brand-500 text-white px-4 py-2 rounded-md text-sm font-medium"
              >
                Add Article
              </Link>
        </div>
      </div>

      <div className="bg-white rounded-md shadow-sm border">
        <ArticleTable
          data={paginatedData}
          onDelete={handleDelete}
          onRefresh={fetchData}
        />

        <div className="flex justify-between items-center px-4 py-3 border-t text-sm">
          <span className="text-gray-500">
            {filteredData.length} total
          </span>

          <div className="flex items-center gap-1">
            <select
              value={limit}
              onChange={(e) => {
                setLimit(Number(e.target.value));
                setPage(1);
              }}
              className="border rounded-md px-2 py-2 text-sm"
            >
              <option value={10}>10 / page</option>
              <option value={25}>25 / page</option>
              <option value={50}>50 / page</option>
            </select>

            <button
              disabled={page === 1}
              onClick={() => setPage(1)}
              className="p-2 border rounded"
            >
              <MdFirstPage />
            </button>

            <button
              disabled={page === 1}
              onClick={() => setPage(page - 1)}
              className="p-2 border rounded"
            >
              <MdChevronLeft />
            </button>

            <span className="px-3 font-medium">
              {page} / {totalPages || 1}
            </span>

            <button
              disabled={page === totalPages}
              onClick={() => setPage(page + 1)}
              className="p-2 border rounded"
            >
              <MdChevronRight />
            </button>

            <button
              disabled={page === totalPages}
              onClick={() => setPage(totalPages)}
              className="p-2 border rounded"
            >
              <MdLastPage />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
